import posthog from 'posthog-js';

// Helper functions for PostHog analytics
// Note: Initialization is handled in main.tsx via PostHogProvider

// Track custom events
export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
    posthog.capture(eventName, properties);
};

// Identify user
export const identifyUser = (userId: string, properties?: Record<string, any>) => {
    posthog.identify(userId, properties);
};

// Reset user (on logout)
export const resetUser = () => {
    posthog.reset();
};

// Track page views manually (if not using the hook/component)
export const trackPageView = (pageName?: string) => {
    posthog.capture('$pageview', pageName ? { page: pageName } : undefined);
};

// Set user properties
export const setUserProperties = (properties: Record<string, any>) => {
    posthog.people.set(properties);
};

// Feature flags
export const isFeatureEnabled = (flagKey: string): boolean => {
    return posthog.isFeatureEnabled(flagKey) || false;
};

export const getFeatureFlagValue = (flagKey: string): string | boolean | undefined => {
    return posthog.getFeatureFlag(flagKey);
};

export default posthog;
